import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "primary-color overview-name"
}
const _hoisted_2 = {
  class: "pr-2 d-flex",
  style: {"width":"10%"}
}
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = { class: "slider-value" }
const _hoisted_5 = { class: "text-center date-label date-color mt-2" }
const _hoisted_6 = { class: "mt-1" }
const _hoisted_7 = { class: "p-text date-label" }
const _hoisted_8 = { class: "small" }
const _hoisted_9 = { class: "p-text mt-1" }
const _hoisted_10 = { class: "d-flex align-center justify-space-between" }
const _hoisted_11 = { class: "p-text date-label" }
const _hoisted_12 = { class: "p-text mt-1" }

import {useSettingsStore} from "@/api/store/settings";
import {computed, reactive, ref, watch} from "vue";
import {surveysService} from "@/api/services/surveys";
import {useRouter} from "vue-router";
import moment from "moment/moment";
import LeftAndRightArrows from "@/views/DocumentComponents/DocumentSurveys/Partials/LeftAndRightArrows.vue";
import RatingSlider from "@/components/custom/RatingSlider.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentSurveys',
  setup(__props) {

_useCssVars(_ctx => ({
  "v4ae6dfc8": (_unref(buttonColor))
}))

const router = useRouter();
const settingsStore = useSettingsStore();

const buttonColor = settingsStore.settings.buttonColor

const state = reactive({
  surveys: [] as any[],
  latestEntries: [] as any[],
  clientSurveysWithAnswer: [] as any[],
  upcomingSurveys: [] as any[],
  upcomingSurvey: {} as any,
  currentIndex: 0,
});

const questionsState = reactive({
  page: 1,
  hasMorePages: false,
});

const selectedQuestionTitle = ref({
  id: null,
  title: '',
});

const getSurveys = () => {
  
  surveysService.index().then((response) => {
    state.surveys = [...response.active];
    state.latestEntries = [...response.latest_entries];
    state.upcomingSurveys = [...response.upcoming];
    updateCurrentUpcomingSurvey();
    
  });
}

const updateCurrentUpcomingSurvey = () => {
  const currentSurveyId = currentSurvey.value?.id;
  state.upcomingSurvey = state.upcomingSurveys.find(
    upcoming => upcoming.survey_id === currentSurveyId
  ) || {};
}

// Function to handle moving to the next survey
const nextSurvey = () => {
  if (state.currentIndex < state.surveys.length - 1) {
    state.currentIndex++;
  }
}

// Function to handle moving to the previous survey
const previousSurvey = () => {
  if (state.currentIndex > 0) {
    state.currentIndex--;
  }
}

// Function to handle the questions pagination
const nextPage = () => {
  if (questionsState.hasMorePages) {
    questionsState.page++;
    fetchClientSurveysWithAnswer();
  }
}

// Function to handle moving to the previous page on questions pagination
const previousPage = () => {
  if (questionsState.page > 1) {
    questionsState.page--;
    fetchClientSurveysWithAnswer()
  }
}

// Computed property to get the current survey based on currentIndex
const currentSurvey = computed(() => {
  const surveys = [...state.surveys]
  return surveys[state.currentIndex] || {};
});

const fetchClientSurveysWithAnswer = () => {
  
  const questionId = selectedQuestionTitle.value.id;

  if (currentSurvey.value.id && questionId) {
    surveysService.getQuestionsResponse(currentSurvey.value.id, {
      question_id: questionId,
      page: questionsState.page
    }).then((response) => {
      state.clientSurveysWithAnswer = response.data.map((question) => {
        return {
          ...question,
          responses: question.responses[0]?.answer ?? 0,
        }
      });

      // Check if there are more pages available
      questionsState.hasMorePages = response.current_page < response.last_page;

      

    });
  } else {
    state.clientSurveysWithAnswer = []
    
  }
}

watch(currentSurvey, (newValue) => {
  if (newValue && newValue.questions && newValue.questions.length > 0) {
    selectedQuestionTitle.value = {
      id: newValue.questions[0].id,
      title: newValue.questions[0].title,
    };
  } else {
    selectedQuestionTitle.value = {
      id: null,
      title: ''
    }
  }
  updateCurrentUpcomingSurvey();
});

watch(selectedQuestionTitle, fetchClientSurveysWithAnswer);


const getQuestionCompletedDate = (question) => {
  if (question === undefined) return;

  return {
    month: moment(question.completed ?? question.start).format('DD MMM'),
    year: moment(question.completed ?? question.start).format('YYYY'),
  }
}


const getDueOrOverdue = computed(() => {
  const today = moment();
  const surveyStart = moment(state.upcomingSurvey?.start);

  if (today.isSame(surveyStart, 'day')) {
    return '(Due)';
  }

  if (today.isAfter(surveyStart)) {
    return '(Overdue)';
  }

  return '';
});

const disableSurveyIfASurveyWasCompletedToday = computed(() => {
  const today = moment().format('YYYY-MM-DD');
  const currentSurveyId = state.upcomingSurvey?.survey_id;
  
  // Check if there's a completed entry today for the current survey
  const latestEntryToday = state.latestEntries.find((entry) => 
    moment(entry.completed).format('YYYY-MM-DD') === today && 
    entry.survey.id === currentSurveyId
  );

  return !!latestEntryToday;
});

const onComplete = () => {
  router.push({
    name: 'document-survey-form',
    params: {
      surveyId: state.upcomingSurvey.survey_id,
      clientSurveyId: state.upcomingSurvey.id
    },
  });
}

getSurveys()

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pb-5 surveys",
    style: {"background-color":"#F0F0F0","min-height":"500px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, { class: "mx-6 border-rounded" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { class: "d-flex justify-space-between align-center pa-2 pb-0 w-100" }, {
            default: _withCtx(() => [
              (currentSurvey.value)
                ? (_openBlock(), _createBlock(_component_v_card_title, {
                    key: 0,
                    class: "text-h6 font-weight",
                    style: {"width":"90%"}
                  }, {
                    default: _withCtx(() => [
                      _cache[1] || (_cache[1] = _createTextVNode(" Overview ", -1)),
                      (currentSurvey.value.name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(currentSurvey.value?.name) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(LeftAndRightArrows, {
                  onLeft: previousSurvey,
                  onRight: nextSurvey
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_container, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_select, {
                modelValue: selectedQuestionTitle.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedQuestionTitle).value = $event)),
                items: currentSurvey.value?.questions,
                density: "compact",
                "item-id": "id",
                "item-title": "title",
                "return-object": "",
                variant: "solo"
              }, null, 8, ["modelValue", "items"]),
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.clientSurveysWithAnswer, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `survey-${index}`,
                    class: "display-grid question-slider"
                  }, [
                    _createVNode(RatingSlider, {
                      modelValue: question.responses,
                      "onUpdate:modelValue": ($event: any) => ((question.responses) = $event),
                      color: _unref(settingsStore).settings.primaryColor,
                      min: 0,
                      question: question,
                      "show-ticks": false,
                      direction: "vertical",
                      readonly: "",
                      "track-size": "25"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "question"]),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(question.responses), 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createTextVNode(_toDisplayString(getQuestionCompletedDate(question).month) + " ", 1),
                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("p", _hoisted_6, _toDisplayString(getQuestionCompletedDate(question).year), 1)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_container, { class: "d-flex justify-end pt-0" }, {
            default: _withCtx(() => [
              _createVNode(LeftAndRightArrows, {
                onLeft: previousPage,
                onRight: nextPage
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_title, { class: "mx-3 text-h6 font-weight mt-3" }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("Upcoming Surveys", -1)
        ]))]),
        _: 1
      }),
      (Object.keys(state.upcomingSurvey).length > 0)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 0,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_unref(moment)(state.upcomingSurvey?.start).format('DD MMM YYYY')) + " ", 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(getDueOrOverdue.value), 1)
                ]),
                _createElementVNode("p", _hoisted_9, _toDisplayString(state.upcomingSurvey?.survey?.name), 1)
              ]),
              _createVNode(_component_v_btn, {
                color: getDueOrOverdue.value.length === 0 || disableSurveyIfASurveyWasCompletedToday.value ? '#ABAAAA' : _unref(settingsStore).settings.buttonColor2,
                disabled: getDueOrOverdue.value.length === 0 || disableSurveyIfASurveyWasCompletedToday.value,
                class: "text-white b-round-20 complete-button",
                onClick: onComplete
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Complete now ", -1)
                ]))]),
                _: 1
              }, 8, ["color", "disabled"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: 1,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("p", { class: "p-text" }, "You have no active surveys running at this time.", -1)
            ]))]),
            _: 1
          })),
      _createVNode(_component_v_card_title, { class: "mx-3 text-h6 font-weight mt-3" }, {
        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
          _createTextVNode("Latest Entries", -1)
        ]))]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.latestEntries, (entry, index) => {
        return (_openBlock(), _createBlock(_component_v_sheet, {
          key: `entry-${index}`,
          class: "mx-6 pa-3 border-rounded mb-2"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(moment)(entry.completed).format('DD MMM YYYY')), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(entry.survey.name), 1)
              ]),
              _createVNode(_component_v_btn, {
                class: "b-round-20 view-button",
                onClick: ($event: any) => (_unref(router).push({ name: 'document-survey-view', params: { id: entry.id, surveyName: entry.survey.name } }))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" View ", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      (state.latestEntries.length === 0)
        ? (_openBlock(), _createBlock(_component_v_sheet, {
            key: 2,
            class: "mx-6 pa-3 border-rounded d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createElementVNode("p", { class: "p-text" }, "There is no information to show", -1)
            ]))]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})